import React from 'react';

import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { HeaderSummary } from './HeaderSummary';
import { getBudgetSummary } from 'utils/apiRequests';
import { getApiParamsFromFilterModel } from '../BudgetPerformance/utils';
import isEqual from 'lodash/isEqual';
import { Wrapper, LoadingWrapper } from './HeaderSummary.styles';

export class HeaderSummaryContainer extends React.Component {
	state = { data: null };

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		const { filterModel } = this.props;

		if (!isEqual(filterModel, prevProps.filterModel)) {
			this.fetchData();
		}
	}

	getApiParams = () => {
		const { filterModel } = this.props;

		return {
			...getApiParamsFromFilterModel(filterModel),
			monthNumbers: filterModel.monthNumbers,
		};
	};

	fetchData = () => {
		getBudgetSummary(this.getApiParams()).then(data => {
			this.setState({ data });
		});
	};

	render() {
		const { data } = this.state;
		const { spendFormatter } = this.props;

		if (!data) {
			return (
				<Wrapper>
					<LoadingWrapper>
						<ApLoaderDefault loaderText={() => <ApLoaderText />} />
					</LoadingWrapper>
				</Wrapper>
			);
		}

		return <HeaderSummary data={data} spendFormatter={spendFormatter} />;
	}
}
